<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :url="url"
      :allowFields="$lang.search_company_fields"
      :hiddenFields="hiddenFieldList"
      ref="searchCompany"
      :title="$lang.searchCompany"
      :remove_item="remove_item"
      :filterCatch="true"
      :toggleable="true"
      addModalSize="lg"
      removeModalSize="xl"
      :allowEdit="false"
      :dynamicButtons="buttons"
      config="company"
      primaryKey="code"
      @change="RefrenceParent"
    >
      <template slot="addModal" slot-scope="search">
        <AddCompany
          isModal
          @modal-end-up="search.close"
          @getData="getData"
          :parentRefrence="items"
        ></AddCompany>
      </template>
    </Search>
    <Confirm
      v-model="enableConfirm"
      :title="$lang.change_company_state"
      :description="enableConfirmDescription"
      dynamicClass=""
      :loading="enableConfirmLoading"
      :loadingSpinnerText="$lang.updating_data"
      :preventDefault="true"
      :cancel-title="$lang.no"
      :ok-title="$lang.yes"
      @cancel="cancelEnableConfirm"
      @ok="okEnableConfirm"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import Confirm from "@/components/base/confirm";
import AddCompany from "./addCompany";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  components: {
    Search,
    Confirm,
    AddCompany,
  },
  data() {
    return {
      hiddenFieldList: ["created_at.jalali", "created_by"],
      loadingItem: false,
      items: [],
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "2",
          name: "enable",
          click: this.showEnableConfirm,
        },
        {
          id: "3",
          name: "delete",
        },
      ],
      enableConfirm: false,
      enableConfirmLoading: false,
      enableConfirmItem: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["resources", "company"]);
    },
    enableConfirmDescription() {
      const is_enable = pathOr(null, ["is_enable"], this.enableConfirmItem);
      return is_enable
        ? `با غیر فعال سازی شرکت دسترسی به تمام افراد و کاربرها و پرونده‌های ذیل این شرکت و شرکت‌های ذیل آن برای کاربران بسته می شود
      <br><br><strong>آیا از برای غیر فعال سازی شرکت مطمئن هستید ؟</strong>`
        : `با فعال سازی شرکت دسترسی به تمام افراد و کاربرها و پرونده‌های ذیل این شرکت و شرکت‌های ذیل آن برای کاربران فعال می شود
      <br><br><strong>آیا از برای فعال سازی شرکت مطمئن هستید ؟</strong>`;
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.code)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    RefrenceParent(items) {
      let data = items.map((x) => {
        return {
          value: x.code,
          text: x.name,
        };
      });
      this.items = data;
    },
    getData() {
      this.$refs.searchCompany.getItems();
    },
    showEnableConfirm(item) {
      this.enableConfirmItem = item;
      this.enableConfirm = true;
    },
    cancelEnableConfirm() {
      this.enableConfirmItem = null;
      this.enableConfirm = false;
    },
    async okEnableConfirm() {
      try {
        this.enableConfirmLoading = true;
        const { code, is_enable } = this.enableConfirmItem;
        const url = generateApiUrl(["resources", "company_id"], [code]);
        const payload = { is_enable: is_enable ? 0 : 1 };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.cancelEnableConfirm();
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.enableConfirmLoading = false;
      }
    },
  },
};
</script>

